function updateFavouritesDot() {
  const favourites = JSON.parse(localStorage.getItem('favourites') || '[]');
  const favouritesLink = document.getElementById('favourites-link');
  const dot = document.querySelector('.favourites-dot');
  
  if (favourites && Array.isArray(favourites)) {
    if (dot) {
      dot.style.display = favourites.length > 0 ? 'block' : 'none';
    }
  }
}

function toggleFavouriteState(productHandle) {
  let favourites = JSON.parse(localStorage.getItem('favourites') || '[]');
  const wasFavourited = favourites.includes(productHandle);
  
  if (wasFavourited) {
    favourites = favourites.filter(handle => handle !== productHandle);
    
    if (window.location.pathname.includes('/pages/favourites')) {
      const productCard = document.querySelector(`[data-favourite-button="${productHandle}"]`).closest('.product-card');
      if (productCard) {
        productCard.remove();
        
        const favouritesContainer = document.getElementById('favourites-container');
        if (favouritesContainer && favouritesContainer.children.length === 0) {
          const noFavouritesMessage = document.getElementById('no-favourites');
          if (noFavouritesMessage) {
            noFavouritesMessage.style.display = 'block';
          }
        }
      }
    }
  } else {
    favourites.push(productHandle);
    showNotification();
  }
  
  localStorage.setItem('favourites', JSON.stringify(favourites));
  updateAllButtons(productHandle);
  updateFavouritesDot();
}

function updateAllButtons(productHandle) {
  const favourites = JSON.parse(localStorage.getItem('favourites') || '[]');
  const isFavourited = favourites.includes(productHandle);
  
  // Update favourite buttons
  document.querySelectorAll(`[data-favourite-button="${productHandle}"]`).forEach(button => {
    if (isFavourited) {
      button.classList.add('is-favourite');
      button.querySelector('iconify-icon').setAttribute('icon', 'solar:heart-bold');
    } else {
      button.classList.remove('is-favourite');
      button.querySelector('iconify-icon').setAttribute('icon', 'solar:heart-linear');
    }
  });

  // Update multibuy buttons
  document.querySelectorAll(`[data-multibuy-button="${productHandle}"]`).forEach(button => {
    if (isFavourited) {
      button.innerHTML = '<iconify-icon class="mr-4" icon="solar:check-circle-bold" inline width="13" height="13"></iconify-icon>Multibuy ->';
      button.setAttribute('onclick', `window.location.href='/pages/favourites'`);
    } else {
      button.textContent = 'Multibuy';
      button.setAttribute('onclick', `toggleFavouriteState('${productHandle}')`);
    }
  });
}

function showNotification() {
  const notification = document.createElement('div');
  notification.className = 'notification-popup';
  notification.innerHTML = ` <iconify-icon icon="solar:check-circle-bold" inline width="16" height="16"></iconify-icon> Added to Multibuy Favourites List! <a style="color: #fff;" href="/pages/favourites">Compare your products or request a quote here</a>`;
  
  notification.style.cssText = `
    position: fixed;
    bottom: 20px;
    right: 20px;
    left: 20px;
    background: var(--primary-color);
    padding: 15px 20px;
    color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    z-index: 1000;
    animation: fadeInOut 5s forwards;
  `;
  
  if (!document.querySelector('#notification-animation')) {
    const style = document.createElement('style');
    style.id = 'notification-animation';
    style.textContent = `
      @keyframes fadeInOut {
        0% { opacity: 0; transform: translateY(20px); }
        10% { opacity: 1; transform: translateY(0); }
        90% { opacity: 1; transform: translateY(0); }
        100% { opacity: 0; transform: translateY(20px); }
      }
    `;
    document.head.appendChild(style);
  }
  
  document.body.appendChild(notification);
  setTimeout(() => {
    notification.remove();
  }, 5000);
}

function generateShareableLink() {
  const favourites = JSON.parse(localStorage.getItem('favourites') || '[]');
  if (favourites.length === 0) return null;
  
  const url = new URL(`${window.location.origin}/pages/favourites`);
  favourites.forEach(handle => {
    url.searchParams.append('h', handle);
  });
  
  return url.toString();
}

function loadSharedFavourites() {
  const urlParams = new URLSearchParams(window.location.search);
  const handles = urlParams.getAll('h');
  
  if (handles.length > 0) {
    try {
      localStorage.setItem('favourites', JSON.stringify(handles));
      return true;
    } catch (error) {
      console.error('Error loading shared favourites:', error);
      return false;
    }
  }
  return false;
}

// Initialize all buttons on page load
document.addEventListener('DOMContentLoaded', function() {
  const favouriteButtons = document.querySelectorAll('[data-favourite-button]');
  const multibuyButtons = document.querySelectorAll('[data-multibuy-button]');
  const favourites = JSON.parse(localStorage.getItem('favourites') || '[]');
  
  // Initialize favourite buttons
  favouriteButtons.forEach(button => {
    const handle = button.getAttribute('data-favourite-button');
    if (favourites.includes(handle)) {
      button.classList.add('is-favourite');
      button.querySelector('iconify-icon').setAttribute('icon', 'solar:heart-bold');
    }
  });

  // Initialize multibuy buttons
  multibuyButtons.forEach(button => {
    const handle = button.getAttribute('data-multibuy-button');
    if (favourites.includes(handle)) {
      button.innerHTML = '<iconify-icon class="mr-4" icon="solar:check-circle-bold" inline width="13" height="13"></iconify-icon>Multibuy ->';
      button.setAttribute('onclick', `window.location.href='/pages/favourites'`);
    }
  });

  const shareButton = document.querySelector('#favourites-share-list');
  const popoverOverlay = document.getElementById('favourites-popover-overlay');
  const shareInput = document.getElementById('share-link-input');
  const copyButton = document.getElementById('copy-share-link');

  if (shareButton) {
    shareButton.addEventListener('click', function() {
      const shareableUrl = generateShareableLink();
      if (shareableUrl) {
        shareInput.value = shareableUrl;
        popoverOverlay.style.display = 'flex';
      } else {
        alert('No favourites to share!');
      }
    });
  }

  if (copyButton) {
    copyButton.addEventListener('click', function() {
      shareInput.select();
      document.execCommand('copy');
      
      const originalText = copyButton.innerHTML;
      copyButton.innerHTML = '<iconify-icon icon="solar:check-circle-bold" inline width="16" height="16"></iconify-icon> Copied!';
      setTimeout(() => {
        copyButton.innerHTML = originalText;
      }, 2000);
    });
  }

  // Check for shared favourites
  if (loadSharedFavourites()) {
    window.location.href = window.location.pathname;
  }

  // Initialize the favourites dot
  updateFavouritesDot();
});